import { useEffect, useState } from 'react'
import { getGoals } from 'utils/getSupportingInfo'
import { getRequest } from 'utils/api'
import { ASSESSMENT_RATINGS_TIMELINE_URL } from 'services/constants'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import { NotificationBodyText } from 'components/atoms/Text'
import { useTranslation } from 'react-i18next'
import { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import OverlayLoading from 'components/atoms/OverlayLoading'
import colors from 'styles/colors'
import AssessmentHeader from 'components/molecules/assessments/pathAssessment/AssessmentHeader'
import AssessmentInfo from 'components/molecules/assessments/pathAssessment/AssessmentInfo'
import AssessmentGraph from 'components/molecules/assessments/pathAssessment/AssessmentGraph'
import AssessmentChange from 'components/molecules/assessments/pathAssessment/AssessmentChange'

const PathAssessmentCard = ({ goal }) => {
  const { t } = useTranslation()
  const [goalData, setGoalData] = useState(null)
  const [goals, setGoals] = useState([])
  const [timelineData, setTimelineData] = useState([])
  const [requestError, setRequestError] = useState(undefined)
  const [openAssessmentNote, setOpenAssessmentNote] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      setGoalData(null)
      const goalsData = await getGoals()
      setGoals(goalsData)
      const goalInfo = goalsData.find(g => g.id === goal.id)

      setGoalData(goalInfo)
      const res = await getRequest(ASSESSMENT_RATINGS_TIMELINE_URL, {
        goalId: goal.id
      })
      if (res.status === 200) {
        setTimelineData(res.data.data)
        setRequestError(false)
      } else {
        setRequestError(true)
      }
      setLoading(false)
    }
    if (!goalData || goalData?.id !== goal.id) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goal])

  const SectionWrapper = ({ children, ...otherProps }) => {
    return (
      <BoxWithBackground
        backgroundColor={colors.Grey25}
        borderRadius={3}
        width={'100%'}
        {...otherProps}>
        <RowStack spacing={110} justifyContent={'center'} position={'relative'}>
          {children}
        </RowStack>
      </BoxWithBackground>
    )
  }

  return (
    <ColStack spacing={16} paddingBottom={16}>
      <OverlayLoading open={loading} />

      {!loading && goalData && (
        <>
          <AssessmentHeader goals={goals} selectedGoal={goalData} />
          {timelineData.length > 0 ? (
            <>
              <SectionWrapper paddingY={20}>
                <RowStack
                  spacing={35}
                  justifyContent={'space-evenly'}
                  position={'relative'}>
                  <AssessmentInfo
                    goalData={goalData}
                    timelineData={timelineData[0]}
                  />

                  <AssessmentGraph timelineData={timelineData[0]} />
                </RowStack>
              </SectionWrapper>

              <SectionWrapper padding={12}>
                <AssessmentChange data={timelineData} />
              </SectionWrapper>
            </>
          ) : (
            <NotificationBodyText textAlign='center'>
              {t('assessmentTimeline.noAssessmentData')}
            </NotificationBodyText>
          )}

          {requestError && <RequestRetryAlert />}

          <CommonDialog
            open={openAssessmentNote}
            onClose={() => setOpenAssessmentNote(false)}
            notificationText={t(
              'assessmentTimeline.alreadyCompletedSelfassessment'
            )}
            confirmText={t('common.ok')}
          />
        </>
      )}
    </ColStack>
  )
}
export default PathAssessmentCard
